import { DXG_PHONE_TYPES_BY_PRIORITY } from '@makemydeal/dr-shared-types';
import type { QualifiedPhoneNumbers } from '@makemydeal/dr-shared-types';

export type CellPhoneResolutionInput = Partial<QualifiedPhoneNumbers> & {
    phone?: string;
};

const digitsOnly = (phone?: string): string => (phone ?? '').replace(/\D/g, '');

const isSameNumber = (left?: string, right?: string): boolean => {
    const normalized = digitsOnly(left);
    return normalized !== '' && normalized === digitsOnly(right);
};

export const resolveCellPhone = ({ cellPhone, homePhone, workPhone, phone }: CellPhoneResolutionInput): string => {
    if (cellPhone) return cellPhone;
    if (!phone) return '';
    if (isSameNumber(phone, homePhone) || isSameNumber(phone, workPhone)) return '';
    return phone;
};

export const resolvePrimaryPhone = (phones: Partial<QualifiedPhoneNumbers>): string =>
    DXG_PHONE_TYPES_BY_PRIORITY.map(({ phoneType }) => phones[phoneType]).find(Boolean) ?? '';
